import React from 'react';

export const BackRightIcon = ({ props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    {...props}
  >
    <title>back</title>
    <g id="g51" transform="matrix(-1,0,0,1,24,0)">
      <path
        d="M 11.999,9 6,14.241 6.657,15 11.999,10.334 17.343,15 18,14.241 Z"
        transform="matrix(0,1,1,0,0,0)"
        id="path28"
      />
    </g>
  </svg>
);
